// src/components/LoginForm.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/login.css';
import { IconEye, IconEyeOff } from '@tabler/icons-react';

export default function LoginForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    const url = `https://pedidos.ayvgas.cl/auth/login.php?username=${encodeURIComponent(
      username
    )}&password=${encodeURIComponent(password)}`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (!res.ok) {
        setError('Error en la solicitud. Intenta más tarde.');
      } else if (data.success) {
        setSuccess(data.message || 'Inicio de sesión exitoso');
        if (data.token) localStorage.setItem('token', data.token);
        if (data.role) localStorage.setItem('role', data.role);
        if (data.ciudad) localStorage.setItem('ciudad_usuario', data.ciudad);

        setTimeout(() => navigate('/welcome/pedidos'), 1200);
      } else {
        setError(data.message || 'Credenciales incorrectas.');
      }
    } catch (err) {
      setError('Error de conexión con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="content" className="content">
      <div className="login-card" role="dialog" aria-labelledby="login-title">
        <h2 id="login-title">🔐 Bienvenido</h2>

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          <label htmlFor="username">Usuario</label>
          <input
            id="username"
            type="text"
            placeholder="ej: supervisor01"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />

          <label htmlFor="password">Contraseña</label>
          <div className="password-wrapper">
            <input
              id="password"
              type={showPassword ? 'text' : 'password'}
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
              title={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            >
              {showPassword ? <IconEyeOff size={20} /> : <IconEye size={20} />}
            </span>
          </div>

          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}

          <button type="submit" disabled={loading}>
            {loading ? 'Cargando...' : 'Ingresar'}
          </button>
        </form>
      </div>
    </div>
  );
}
